import React from 'react'
import packageStyles from './diningpackage.module.sass'
import ButtonLink from './ButtonLink'

const TPBookingURL = 'https://booking.welcome-anywhere.net/connect/9602'
const email = 'thefront@trufflepigs.com'

export default props => {
  const {
    package_name,
    package_description,
    price_per_person,
  } = props.diningpackage

  // const buttonContext = packageStyles.diningpackage + "--buttonlink"
  const buttonText = `$${price_per_person} per person`

  return (
    <div className={packageStyles.diningpackage}>
      <h3 className={packageStyles.name}>{package_name}</h3>
      <p
        className={packageStyles.desc}
        dangerouslySetInnerHTML={{
          __html: package_description,
        }}
      />
      <ButtonLink
        email={email}
        url={TPBookingURL}
        text={buttonText}
        variant="default"
        addClass={packageStyles.buttonlink}
      />
    </div>
  )
}
